import type { Brand } from '@studio/models/device';
import { isNotNil } from '@tryiris-ai/js-types';
import { mutex } from './constants.js';
import type { Collection } from '#~/api/device/registry/index.js';
import { fetchBrands } from '#~/api/device/registry/index.js';
import { depot } from '#~/depot/index.js';

/**
 * Returns the brands in the device registry.
 *
 * @returns The set brands in the device registry.
 */
export const getBrands = async (token: string): Promise<Collection<Brand>> => {
  const { produce, registry } = depot.getState();

  // Have we already fetched the brands?
  if (isNotNil(registry.brands)) {
    return registry.brands;
  }

  // Fetch the device brands.
  return mutex.runExclusive(async () => {
    // Do we still need to run?
    const { brands } = depot.getState().registry;

    if (isNotNil(brands)) {
      return brands;
    }

    // Fetch the device brands.
    const result = await fetchBrands(token);

    produce((draft) => {
      draft.registry.brands = result;
    });

    return result;
  });
};
